<template>
  <div id="video-player" :class="{ 'full-video': isFull }" v-if="isPlay">
    <div class="paly-content">
      <i class="iconfont icon-shanchu3" @click="closePlay"></i>
      <!-- 视频流 -->
      <template v-if="isVideoStream">
        <vueVideoStream ref="vueVideoStreamRef" :src="audioUrl"></vueVideoStream>
      </template>
      <!-- 普通MP4格式 -->
      <video v-else controls autoplay>
        <source :src="audioUrl" />
      </video>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'videoPlayer',
    data() {
      return {
        audioUrl: '',
        isPlay: false,
        isFull: false,
        isVideoStream: false, // 是否是视频流
        token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
      }
    },
    components: {
      vueVideoStream: () => import('./cpns/vueVideoStream.vue'),
    },
    methods: {
      // 关闭播放
      closePlay () {
        if (this.$refs.vueVideoStreamRef) {
          this.$refs.vueVideoStreamRef.disconnect()
        }
        this.isPlay = false
        this.audioUrl = ''
      },
      // 开始播放
      async paly (url, obj = { isFull: false, isVideoStream: false }) {
        const { isFull, isVideoStream } = obj
        this.isFull = isFull
        this.isVideoStream = isVideoStream
        const player = document.querySelector('#video-player')
        if (player) {
          const playerF =  player.parentElement;
          playerF.removeChild(player);
        }
        if (url.includes('?')) {
          // 存在参数：替换或添加token
          const urlObj = new URL(url, window.location.origin);
          urlObj.searchParams.set('accesstoken', this.token); // 存在则替换，不存在则添加
          url = urlObj.toString();
        } else {
          // 无参数：直接追加token
          url = `${url}?accesstoken=${this.token}`;
        }
        this.audioUrl = url
        this.isPlay = true
      },
    }
  }
</script>

<style lang="scss" scoped>
  #video-player {
    background: rgba(0, 0, 0, .6);
    z-index: 2999;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .paly-content {
      width: 65%;
      height: 65%;
      padding: 30px;
      box-sizing: border-box;
      position: relative;
      background-color: #000;
      .icon-shanchu3 {
        position: absolute;
        cursor: pointer;
        top: 10px;
        right: 10px;
        font-size: 24px;
        color: #FFF;
        &:hover {
          color: #4e86ff;
        }
      }
      video {
        width: 100%;
        height: 100%;
        background: #000;
      }
    }

  }
  .full-video {
    .paly-content {
      width: 100% !important;
      height: 100% !important;
    }
  }
</style>
